import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const sidebarLinks = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'bx bx-home-circle',
    path: '/admin/dashboard',
    isHeader: false,
  },
    {
    id: 'sliders',
    label: 'Sliders',
    icon: 'bx bx-slider',
    path: '/admin/sliders',
    external: false,
  }, 
    {
    id: 'brands',
    label: 'Brands',
    icon: 'bx bx-purchase-tag',
    path: '/admin/brands',
    external: false,
  }, 
   {
    id: 'Home Page Setting Manage',
    label: 'Home Page Setting Manage',
    icon: 'bx bx-cog',
      dropdown: [
    
      { path: '/admin/home-section-products', label: 'Home section products' },
     
    ],
  },
   
  {
    id: 'categories',
    label: 'Categories Manage', 
    icon: 'bx bx-layout',
    dropdown: [
      { path: '/admin/categories', label: 'Categories' },
      { path: '/admin/sub-categories', label: 'Sub Categories' },
      {path:'/admin/child-categories', label:'Child Categories'}
    ],
  },
  {
    id: 'product',
    label: 'Product Manage',
    icon: 'bx bx-package',
    dropdown: [ 
      { path: '/admin/all-products', label: 'All Products' },
      { path: '/admin/active-products', label: 'Active Products' },
      { path: '/admin/inactive-products', label: 'Inactive Products' },
      { path: '/admin/all-sold-products', label: 'Sold Products' },
      { path: '/admin/all-offers-products', label: 'Offer Products' },

    ],
  },

  //   {
  //   id: 'productReviewList',
  //   label: 'Product Review List',
  //   icon: 'bx bx-message',
  //   dropdown: [
  //     { path: '/admin/product-review', label: 'Product Review' },
  //   ],
  // },

    {
    id: 'orderManage',
    label: 'Orders Manage',
    icon: 'bx bx-cart-alt',
    dropdown: [
      { path: '/admin/all-orders', label: 'All Orders' },
      { path: '/admin/new-orders', label: 'New Orders' },
      { path: '/admin/delivered-orders', label: 'Delivered Orders' },
      { path: '/admin/cancelled-orders', label: 'Cancelled Orders' },
      { path: '/admin/pending-orders', label: 'Pending Orders' },
    ],
  },

      // {
      //   id: 'paymentManageSettings',
      //   label: 'Payment Settings',
      //   icon: 'bx bx-credit-card',
      //   dropdown: [
      //     { path: '/admin/cod-settings', label: 'COD Settings' },
      //     { path: '/admin/paypal-settings', label: 'Paypal Settings' },
      //     { path: '/admin/payu-settings', label: 'PayU Settings' },
      //   ],
      // },

    {
    id: 'transactions',
    label: 'Transactions',
    icon: 'bx bx-wallet',
    path: '/admin/transactions',
    external: false,
  },

  {
  id: 'customerManagement',
  label: 'Customer Management',
  icon: 'bx bx-group',   // changed from 'bx bx-user'
  path: '/admin/customer-management',
  external: false,
},

{
  id: 'contactUsList',
  label: 'Contact Us List',
  icon: 'bx bx-envelope',   // changed from 'bx bx-user'
  path: '/admin/contact-us-list',
  external: false,
},


  // {
  //   id: 'pages',
  //   label: 'Pages',
  //   isHeader: true,
  // },
  // {
  //   id: 'websiteManage',
  //   label: 'Website Manage',
  //   icon: 'bx bx-detail',
  //   dropdown: [
  //     { path: '/admin/sliders', label: 'Sliders' },
  //     { path: '/admin/home-page-settings', label: 'Home Page Settings' },
  //     { path: '/admin/vendor-conditions', label: 'Vendor Conditions' },
  //     { path: '/admin/about', label: 'About' },
  //     { path: '/admin/terms-and-conditions', label: 'Terms & Conditions' },
  //   ],
  // },
  // {
  //   id: 'blogsmanage',
  //   label: 'Blog Manage',
  //   icon: 'bx bx-detail',
  //   dropdown: [
  //     { path: '/admin/blog-categories', label: 'Category' },
  //     { path: '/admin/blogs', label: 'Blogs' },
  //     { path: '/admin/blog-comments', label: 'Blog Comments' },
  //   ],
  // },
  // {
  //   id: 'account',
  //   label: 'Account Settings',
  //   icon: 'bx bx-dock-top',
  //   dropdown: [
  //     { path: '/pages-account-settings-account', label: 'Account' },
  //     { path: '/pages-account-settings-notifications', label: 'Notifications' },
  //     { path: '/pages-account-settings-connections', label: 'Connections' },
  //   ],
  // },
  // {
  //   id: 'auth',
  //   label: 'Authentications',
  //   icon: 'bx bx-lock-open-alt',
  //   dropdown: [
  //     { path: '/auth-login-basic', label: 'Login' },
  //     { path: '/auth-register-basic', label: 'Register' },
  //     { path: '/auth-forgot-password-basic', label: 'Forgot Password' },
  //   ],
  // },
  // {
  //   id: 'misc',
  //   label: 'Misc',
  //   icon: 'bx bx-cube-alt',
  //   dropdown: [
  //     { path: '/pages-misc-error', label: 'Error' },
  //     { path: '/pages-misc-under-maintenance', label: 'Under Maintenance' },
  //   ],
  // },
  // {
  //   id: 'settingsAndMore',
  //   label: 'Settings & More',
  //   isHeader: true,
  // },
  // {
  //   id: 'footerSettings',
  //   label: 'Footer Settings',
  //   icon: 'bx bx-detail',
  //   dropdown: [
  //     { path: '/admin/footer-info', label: 'Footer Info' },
  //     { path: '/admin/footer-socials', label: 'Footer Socials' },
  //     { path: '/admin/footer-grid-two', label: 'Footer Grid Two' },
  //     { path: '/admin/footer-grid-three', label: 'Footer Grid Three' },
  //   ],
  // },
  // {
  //   id: 'settings',
  //   label: 'Settings',
  //   icon: 'bx bx-cog',
  //   dropdown: [
  //     { path: '/admin/general-setting', label: 'General Setting' },
  //     { path: '/admin/email-configuration', label: 'Email Configuration' },
  //     { path: '/admin/logo-and-favicon', label: 'Logo & Favicon' },
  //     { path: '/admin/pusher-setting', label: 'Pusher Setting' },
  //   ],
  // },
  // {
  //   id: 'extended',
  //   label: 'Extended UI',
  //   icon: 'bx bx-copy',
  //   dropdown: [
  //     { path: '/extended-ui-perfect-scrollbar', label: 'Perfect scrollbar' },
  //     { path: '/extended-ui-text-divider', label: 'Text Divider' },
  //   ],
  // },
  {
    id: 'icons',
    label: 'Shipping Rule',
    icon: 'bx bx-archive',
    path: '/admin/shipping-rule',
  },
  
  // {
  //   id: 'formsTables',
  //   label: 'Forms & Tables',
  //   isHeader: true,
  // },
  // {
  //   id: 'tables',
  //   label: 'Tables',
  //   icon: 'bx bx-table',
  //   path: '/tables-basic',
  // },
  // {
  //   id: 'miscSection',
  //   label: 'Misc',
  //   isHeader: true,
  // },
  // {
  //   id: 'support',
  //   label: 'Support',
  //   icon: 'bx bx-support',
  //   path: 'https://github.com/themeselection/sneat-html-admin-template-free/issues',
  //   external: true,
  // },
  // {
  //   id: 'documentation',
  //   label: 'Documentation',
  //   icon: 'bx bx-file',
  //   path: 'https://themeselection.com/demo/sneat-bootstrap-html-admin-template/documentation/',
  //   external: true,
  // },
];

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);

  const toggleMenu = (menuId) => {
    setActiveMenu(activeMenu === menuId ? null : menuId);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let activeId = null;
    for (const menu of sidebarLinks) {
      if (menu.dropdown) {
        if (menu.dropdown.some((item) => location.pathname.startsWith(item.path))) {
          activeId = menu.id;
          break;
        }
      } else if (menu.path && location.pathname === menu.path) {
        activeId = menu.id;
        break;
      }
    }
    setActiveMenu(activeId);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <aside
        style={{
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          width: '256px',
          backgroundColor: '#fff',
          boxShadow: '0 2px 8px rgba(84, 56, 56, 0.1)',
          transform: isMobile
            ? isOpen
              ? 'translateX(0)'
              : 'translateX(-100%)'
            : 'translateX(0)',
          transition: 'transform 0.3s ease-in-out',
          zIndex: 2000,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Sidebar header */}
        <div
          style={{
            padding: '0.2rem 0.2rem 0rem 0.2rem ',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >

          <Link to="/admin/dashboard" style={{ display: 'flex', textDecoration: 'none' }}>
            <span style={{ fontWeight: 700, fontSize: '1.25rem', color: '#333' }}>
              <img src="/Pharmacy_logo_1.svg" style={{ height: '60px', width: '140px', objectFit: 'contain', marginLeft: '20px', }} alt="Loogo" />
            </span>
          </Link>

          {isMobile && (
            <Link
              onClick={(e) => {
                e.preventDefault();
                toggleSidebar();
              }}
              style={{
                fontSize: '1.5rem',
                color: '#566a7f',
              }}
            >
              <i className="bx bx-x" />
            </Link>
          )}
        </div>

        {/* Sidebar content */}
        <ul style={{ listStyle: 'none', padding: '0.1rem 0', margin: 0, flex: 1, overflowY: 'auto' }}>
          {sidebarLinks.map((menu) => (
            <React.Fragment key={menu.id}>
              {menu.isHeader ? (
                <li style={{ padding: '0.2rem 0.2rem', fontSize: '0.75rem', color: '#a1acb8', textTransform: 'uppercase' }}>
                  {menu.label}
                </li>
              ) : (
              <li style={{ padding: '0.001rem 1rem' }}>
                  {menu.dropdown ? (
                    <>
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleMenu(menu.id);
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          textDecoration: 'none',
                          color: activeMenu === menu.id ? '#164E4F' : '#566a7f',
                          backgroundColor: activeMenu === menu.id ? 'rgb(22, 78, 79, 0.2);' : 'transparent',
                          padding: '0.3rem',
                          borderRadius: '4px',
                        }}
                      >
                        <i className={menu.icon} style={{ marginRight: '0.5rem' }} />
                        <span>{menu.label}</span>
                        <i
                          className={activeMenu === menu.id ? 'bx bx-chevron-up' : 'bx bx-chevron-down'}
                          style={{ marginLeft: 'auto' }}
                        />
                      </Link>
                      <ul style={{ paddingLeft: '1.5rem', display: activeMenu === menu.id ? 'block' : 'none' }}>
                        {menu.dropdown.map((item, i) => (
                          <li key={i}>
                            <Link
                              to={item.path}
                              style={{
                                display: 'block',
                              padding: '0.25rem 0.5rem',
                                textDecoration: 'none',
                                color: isActive(item.path) ? '#164E4F' : '#566a7f',
                                fontWeight: isActive(item.path) ? 600 : 400,
                                backgroundColor: isActive(item.path) ? 'rgba(22, 78, 79, 0.2)' : 'transparent',
                                borderRadius: '4px',
                              }}
                            >
                              {/* <i className="bx bx-chevron-right" style={{ marginRight: '0.5rem' }} /> */}
                              {item.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <Link
                      to={menu.path}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        color: isActive(menu.path) ? '#164E4F' : '#566a7f',
                        backgroundColor: isActive(menu.path) ? 'rgba(22, 78, 79, 0.2)' : 'transparent',
                        padding: '0.3rem',
                        borderRadius: '4px',
                      }}
                      target={menu.external ? '_blank' : '_self'}
                    >
                      <i className={menu.icon} style={{ marginRight: '0.5rem' }} />
                      <span>{menu.label}</span>
                    </Link>
                  )}
                </li>
              )}
            </React.Fragment>
          ))}
        </ul>
      </aside>

      {/* Overlay for mobile */}
      {isOpen && isMobile && (
        <div
          onClick={toggleSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1999,
          }}
        />
      )}
    </>
  );
};

export default Sidebar;